import { TRIGGER_INITIATE_MATCH_PAYMENT_API, TRIGGER_INITIATE_MATCH_PAYMENT_API_SUCCESS } from 'redux/actionTypes';

export function triggerInitiateMatchPaymentApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_INITIATE_MATCH_PAYMENT_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerInitiateMatchPaymentApiCallSuccess(data) {
	return {
		type: TRIGGER_INITIATE_MATCH_PAYMENT_API_SUCCESS,
		data,
	};
}
